import { apiFetch } from "./client";

export type ProviderName = "brevo" | "resend";

export interface ProviderConfig {
  domain: string;
  primary: ProviderName;
  fallback: ProviderName | null;
  fromAddressDefault?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProviderKeyStatus {
  provider: ProviderName;
  apiKeySet: boolean;
  apiKeyLastModified?: string;
  webhookSecretSet: boolean;
  webhookSecretLastModified?: string;
}

export interface UpdateKeysBody {
  apiKey?: string;
  webhookSecret?: string;
}

export const providersApi = {
  list: () => apiFetch<{ providers: ProviderConfig[] }>("/providers"),
  upsert: (
    domain: string,
    data: { primary: ProviderName; fallback: ProviderName | null; fromAddressDefault?: string },
  ) => apiFetch<ProviderConfig>(`/providers/${domain}`, { method: "PUT", body: JSON.stringify(data) }),
  remove: (domain: string) => apiFetch<void>(`/providers/${domain}`, { method: "DELETE" }),
  listKeys: () => apiFetch<{ providers: ProviderKeyStatus[] }>("/provider-keys"),
  updateKeys: (provider: ProviderName, data: UpdateKeysBody) =>
    apiFetch<ProviderKeyStatus>(`/provider-keys/${provider}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
};
